var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-section bg-figma-3 print__no-break print__no-bg"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_vm._m(0),_c('div',[(_vm.comments)?_c('p',{staticClass:"mb-3 whitespace-pre-wrap"},[_vm._v(_vm._s(_vm.comments))]):_vm._e()])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"text-2xl md:text-4xl"},[_vm._v("Notes")])])
}]

export { render, staticRenderFns }